import { render, staticRenderFns } from "./CertidoesUGs.vue?vue&type=template&id=64066d0e&scoped=true"
import script from "./CertidoesUGs.vue?vue&type=script&lang=ts"
export * from "./CertidoesUGs.vue?vue&type=script&lang=ts"
import style0 from "./CertidoesUGs.vue?vue&type=style&index=0&id=64066d0e&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "64066d0e",
  null
  
)

export default component.exports